import React from 'react';
import { getRoleClassName } from '../utils/roles';
import { recallInvite } from '../utils/api';
import './_UserTiles.css';
import './_Buttons.css';

const SchoolInviteCard = ({ invite, onRecall }) => {


    return (
        <div className="user-tile">
            <div className="card-header">
                <h3>{invite.user.first_name} {invite.user.last_name}</h3>
            </div>
            <div className="card-body">
                <p><strong>Inviter:</strong> {invite.inviter.first_name} {invite.inviter.last_name}</p>
                {invite.roles && (
                    <div className="roles-container">
                        {invite.roles.map(role => (
                            <div key={role.id} className={`role-tile ${getRoleClassName(role.name)}`}>{role.name}</div>
                        ))}
                    </div>
                )}
            </div>
            <div className="actions-centered">
                <button onClick={() => onRecall(invite.id)} className="submit-button text-button">Recall</button>
            </div>
        </div>
    );
};

export default SchoolInviteCard;